import { AttributeCarryForward } from '../../beans/attributecarryforward';
import { CommonEnums } from '../../common.enums';

export class Transformation {
    obj_Id: number;
    objNm: string;
    text: string;
    obj_Cd: string;
    dbTyp_Id: number;
    nativeDbTyp_Id: number;
    imageUrl: string;
    name: string;
    expanded: boolean;
    items: Array<AttributeCarryForward>;
    checked: string;

    constructor() {
        this.obj_Id = -1;
        this.objNm = '';
        this.text = '';
        this.obj_Cd = '';
        this.dbTyp_Id = -1;
        this.nativeDbTyp_Id = -1;
        this.imageUrl = '';
        this.name = '';
        this.expanded = false;
        this.items = new Array<AttributeCarryForward>();
        this.checked = CommonEnums.flag.NO;
    }
}